// extracted by mini-css-extract-plugin
export default {"wrap":"ChatModal_wrap__oaPrG"};